export default __webpack_public_path__ + "static/media/18.8ad40ee7.webp";